import React from "react";
import CancelButton from "../ui/cancelbutton";
import Button from "../ui/button";

/**
 * 🧩 Step 1 Modal — Preview section/item details before delete
 */
export const DeletePreviewModal = ({ 
  title = "Details", 
  data = {}, 
  onCancel, 
  onProceed 
}) => {
  if (!data) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-2xl">
        <h3 className="text-lg font-semibold text-gray-900 mb-4 border-b pb-2">
          {title}
        </h3>

        {/* Two-column layout */}
        <div className="text-gray-700 text-sm mb-6 divide-y divide-gray-100">
          {Object.entries(data).map(([key, value]) => (
            <div
              key={key}
              className="flex justify-between items-center py-2"
            >
              <span className="font-medium text-gray-600 capitalize">
                {key.replace(/_/g, " ")}:
              </span>
              <span className="text-gray-800 text-right max-w-[55%] truncate">
                {value || "—"}
              </span>
            </div>
          ))}
        </div>

        <p className="text-gray-600 mb-6">
          Do you want to delete this item?
        </p>

        <div className="flex justify-end gap-3">
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
          <Button onClick={onProceed} bgColor="bg-confirmColor">
            Yes, Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

/**
 * 🧾 Step 2 Modal — Final delete confirmation
 */
export const FinalDeleteConfirmModal = ({ 
  title = "Confirm Delete", 
  message = "Are you sure you want to permanently delete this item?", 
  onCancel, 
  onConfirm 
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4 shadow-2xl">
        <h3 className="text-lg font-semibold text-gray-900 mb-3 border-b pb-2">
          {title}
        </h3>
        <p className="text-gray-700 mb-6">{message}</p>
        <div className="flex justify-end gap-3">
          <CancelButton onClick={onCancel}>Cancel</CancelButton>
          <Button onClick={onConfirm} bgColor="bg-confirmColor">
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};
